import { all, fork, take, put, select, takeLatest } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { RouterTypes, RouterActions } from './router.redux';
import browserHistory from '../../shared/utils/history';
import UnsupportedBrowserDetection from '../../shared/utils/unsupportedBrowserDetection';
import { StartupTypes } from '../startup';
import { FiltersActions, selectIsModalVisible as selectIsFilterModalVisible } from '../filters';
import { AuthActions, selectIsModalVisible as selectIsAuthModalVisible } from '../auth';
import { DEFAULT_FILTER_NAME } from '../filters/filters.constants';
import { DISABLED_SCROLL_TO_TOP_ROUTES } from '../../routes/routes';
import { resetScroll } from '../../shared/utils/scroll';
import { selectPrevPathname } from './router.selectors';

const createHistoryEventChannel = () =>
  eventChannel(emit => {
    const unlisten = browserHistory.listen(location => {
      if (UnsupportedBrowserDetection.isSafari()) {
        return Promise.resolve().then(() => emit(location));
      }

      return requestAnimationFrame(() => emit(location));
    });

    return () => unlisten();
  });

function* closeChannelOnNewListenOrStopAction(channel) {
  while (true) {
    yield take(StartupTypes.STARTUP);
    channel.close();
  }
}

function* hideModals() {
  const isFilterModalVisible = yield select(selectIsFilterModalVisible);
  const isAuthModalVisible = yield select(selectIsAuthModalVisible);

  if (isFilterModalVisible) {
    yield put(FiltersActions.animateModalByFilterName(DEFAULT_FILTER_NAME));
  }

  if (isAuthModalVisible) {
    yield put(AuthActions.hideModal());
  }
}

function* listenHistoryEvents() {
  const channel = createHistoryEventChannel();
  yield fork(closeChannelOnNewListenOrStopAction, channel);

  // eslint-disable-next-line
  while (true) {
    // yield hideModals();
    const location = yield take(channel);
    const locationPath = location.pathname + location.hash;
    yield put(RouterActions.setCurrentPathname(location.pathname));

    if (!DISABLED_SCROLL_TO_TOP_ROUTES.some(i => locationPath.includes(i))) {
      resetScroll();
    }
  }
}

function* listen() {
  yield fork(listenHistoryEvents);
}

function* setCurrentPathname({ pathname }) {
  const prevPathname = yield select(selectPrevPathname);
  if (pathname !== prevPathname) {
    yield hideModals();
  }
}

export default function* startupSaga() {
  yield all([takeLatest(RouterTypes.LISTEN, listen), takeLatest(RouterTypes.SET_CURRENT_PATHNAME, setCurrentPathname)]);
}
